import React from 'react';
import './styles.css';

const sizes = {
  sm: 'spinner-sm',    // 16px
  md: 'spinner-md',    // 24px
  lg: 'spinner-lg'     // 32px
};

const variants = {
  primary: 'spinner-primary',
  secondary: 'spinner-secondary',
  white: 'spinner-white'
};

export const Spinner = ({
  size = 'md',
  variant = 'primary',
  className = '',
  ...props
}) => {
  const classes = [
    'spinner',
    sizes[size],
    variants[variant],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      <div className="spinner-circle"></div>
      <span className="sr-only">Chargement...</span>
    </div>
  );
}; 